<template>
  <div class="projectPage">
    <Header
      :menuIndex="1"
      :banner="bannerImg"
      mainTitle="e勘察数字服务系统"
      mainTitleTop="24%"
      mainTitleLeft="20%"
      subTitle="让勘察过程更加科学化和标准化"
      subTitleTop="42%"
      subTitleLeft="20%"
      btnLeft="11%"
    />
    <div class="navBar">
      <div class="container">
        <div
          class="item"
          v-for="(item, index) in navBarList"
          :key="index"
          :class="{ active: activeIndex == index }"
          @click="changeActiveIndex(index)"
        >
          {{ item }}
        </div>
      </div>
    </div>
    <div class="container" ref="sectionA">
      <section class="sectionA">
        <div class="sec-title">{{ navBarList[0] }}</div>
        <div class="content">
          <div class="item" v-for="(item, index) in sectionAList" :key="index">
            <img :src="item.img" alt="" />
            <div class="info">
              <div class="title">{{ item.title }}</div>
              <div class="desc">{{ item.desc }}</div>
            </div>
          </div>
        </div>
      </section>
    </div>
    <section class="sectionB" ref="sectionB">
      <div class="container">
        <div class="sec-title">{{ navBarList[1] }}</div>
        <div class="content">
          <div class="item" v-for="(item, index) in sectionBList" :key="index">
            <img :src="item.img" alt="" />
            <div class="title">{{ item.title }}</div>
            <div class="desc">{{ item.desc }}</div>
          </div>
        </div>
      </div>
    </section>
    <div class="container" ref="sectionC">
      <section class="sectionC">
        <div class="sec-title">{{ navBarList[2] }}</div>
        <div class="sec-sub-title">数字化勘察，提升工程效率</div>
        <div class="content">
          <div class="tabs">
            <div
              class="item"
              :class="{ active: sectionCActiveIndex == index }"
              v-for="(item, index) in sectionCList"
              :key="index"
              @click="changeSectionC(index)"
            >
              <div class="tab" v-if="sectionCActiveIndex != index">
                {{ item.title }}
              </div>
              <div class="detail" v-if="sectionCActiveIndex == index">
                <div class="title">{{ item.title }}</div>
                <div class="desc">
                  <span v-for="(item_s, indes_s) in item.desc" :key="indes_s">{{
                    item_s
                  }}</span>
                </div>
              </div>
            </div>
          </div>
          <img :src="sectionCList[sectionCActiveIndex].img" alt="" />
        </div>
      </section>
    </div>
    <div class="contactus">
      <div class="title">从这里开始 让勘察更高效</div>
      <div class="btn" @click="$router.push('/application')">联系我们</div>
    </div>
    <Foot />
  </div>
</template>

<script>
var sanweiImg = require("@/assets/product/3D展示.jpg");
var kanbanImg = require("@/assets/product/工作看板.jpg");
var keshihuaImg = require("@/assets/product/可视化展示.jpg");
var projectImg = require("@/assets/product/项目管理.jpg");

export default {
  data() {
    return {
      bannerImg: require("@/assets/banner/7.jpg"),
      navBarList: ["产品优势", "核心功能", "产品展示"],
      activeIndex: 0,
      sectionAList: [
        {
          img: require("@/assets/chanpinyoushi/1.png"),
          title: "提高勘察效率",
          desc: "自动化勘察业务流程，减少人工干预，提高勘察效率",
        },
        {
          img: require("@/assets/chanpinyoushi/2.png"),
          title: "提供精准数据",
          desc:
            "采集、分析和查询大量数据，提供精准的数据支持，帮助企业做出正确的决策",
        },
        {
          img: require("@/assets/chanpinyoushi/3.png"),
          title: "提升数据可视化",
          desc: "将复杂数据可视化展示，让企业管理者更容易理解和分析数据",
        },
        {
          img: require("@/assets/chanpinyoushi/4.png"),
          title: "降低成本",
          desc: "减少人力和时间成本，提高勘察效率，降低企业的勘察成本",
        },
        {
          img: require("@/assets/chanpinyoushi/5.png"),
          title: "提高决策质量",
          desc: "精准的数据支持，帮助企业做出正确的决策，提高决策的质量和效果",
        },
        {
          img: require("@/assets/chanpinyoushi/6.png"),
          title: "促进企业管理",
          desc: "通过全流程服务，使企业管理更加高效",
        },
      ],
      sectionBList: [
        {
          img: require("@/assets/hexingongneng/1.png"),
          title: "项目管理",
          desc:
            "帮助团队更好地跟踪和管理项目质量，提高项目交付的质量和客户满意度。",
        },
        {
          img: require("@/assets/hexingongneng/2.png"),
          title: "工作看板",
          desc: "帮助团队成员更好地管理时间和资源，从而提高工作效率和生产力。",
        },
        {
          img: require("@/assets/hexingongneng/3.png"),
          title: "待办管理",
          desc:
            "可以清晰地列出每项任务的优先级和完成时间，有助于合理安排时间和提高工作效率。",
        },
        {
          img: require("@/assets/hexingongneng/4.png"),
          title: "数据可视化",
          desc:
            "通过图形获取信息的速度比通过阅读文字获取信息的速度要快很多，本系统将数据可视化做到全覆盖。如：钻孔柱状图、剖面图、数据驾驶舱、钻孔平面分布图、项目分布图、可视化大屏等。",
        },
        {
          img: require("@/assets/hexingongneng/5.png"),
          title: "数字交付",
          desc:
            "可以更好地传递地层数据，让客户更容易理解和接受数据，从而促进信息的传递和沟通。",
        },
        {
          img: require("@/assets/hexingongneng/6.png"),
          title: "3D展示",
          desc:
            "帮助用户更直观地了解钻孔的情况，用户可以选择需要查看的钻孔，生成其连线及剖面图，使得用户能够更全面地了解钻孔的情况，从而更好地进行数据分析和决策制定。",
        },
      ],
      sectionCList: [
        {
          title: "可视化展示",
          desc: ["实时流动", "智能决策", "动态展示"],
          img: keshihuaImg,
        },
        {
          title: "项目管理",
          desc: ["流程化", "自动化", "精细化管理"],
          img: projectImg,
          videoUrl: "",
        },
        {
          title: "工作看板",
          desc: ["任务管理", "团队协作", "数据分析"],
          img: kanbanImg,
        },
        {
          title: "3D展示",
          desc: ["交互体验", "增强数据", "可视化分析"],
          img: sanweiImg,
        },
      ],
      sectionCActiveIndex: 0,
    };
  },
  mounted() {
    const options = {
      root: null,
      rootMargin: "0px",
      threshold: 0.5,
    };

    const observer1 = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          this.activeIndex = 0;
        }
      });
    }, options);

    observer1.observe(this.$refs.sectionA);

    const observer2 = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          this.activeIndex = 1;
        }
      });
    }, options);

    observer2.observe(this.$refs.sectionB);

    const observer3 = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          this.activeIndex = 2;
        }
      });
    }, options);

    observer3.observe(this.$refs.sectionC);
  },
  methods: {
    changeActiveIndex(index) {
      this.activeIndex = index;
      switch (index) {
        case 0:
          this.$refs.sectionA.scrollIntoView({ behavior: "smooth" });
          break;
        case 1:
          this.$refs.sectionB.scrollIntoView({ behavior: "smooth" });
          break;
        case 2:
          this.$refs.sectionC.scrollIntoView({ behavior: "smooth" });
          break;
      }
    },
    changeSectionC(index) {
      this.sectionCActiveIndex = index;
    },
  },
};
</script>

<style lang="scss" scoped>
.projectPage {
  .navBar {
    height: 55px;
    position: sticky;
    z-index: 100;
    top: 0;
    background-color: #fff;
    box-shadow: 0 1px 1px 0 #ebedf6;
    > .container {
      display: flex;
      align-items: center;
      .item {
        cursor: pointer;
        margin-right: 50px;
        font-size: 16px;
        line-height: 55px;
        color: #7a8ba6;
        position: relative;
        &::after {
          content: "";
          width: 100%;
          height: 2px;
          background-image: linear-gradient(90deg, #659eff 0, #2466ff 100%);
          position: absolute;
          bottom: 0;
          left: 0;
          opacity: 0;
          transition: all 0.3s;
        }
      }
      .item.active {
        &::after {
          opacity: 1;
        }
      }
    }
  }
  section {
    .sec-title {
      font-size: 28px;
      font-weight: 500;
      line-height: 48px;
      color: #374567;
      text-align: center;
      width: 100%;
      padding-bottom: 72px;
      padding-top: 72px;
    }
  }
  .sectionA {
    padding-bottom: 72px;
    & > .content {
      display: grid;
      column-gap: 150px;
      row-gap: 70px;
      grid-template-columns: 1fr 1fr 1fr;
      grid-template-rows: 132px 132px;
      .item {
        display: flex;
        img {
          width: 30px;
          height: 30px;
          margin-right: 15px;
        }
        .info {
          .title {
            color: #374567;
            font-size: 18px;
            font-weight: 600;
            line-height: 32px;
          }
          .desc {
            margin-top: 16px;
            color: #7a8ba6;
            width: 100%;
            overflow: hidden;
            font-size: 14px;
            line-height: 24px;
            text-align: justify;
          }
        }
      }
    }
  }
  .sectionB {
    width: 100%;
    background-color: #f9faff;
    padding-bottom: 80px;
    .content {
      display: grid;
      column-gap: 25px;
      row-gap: 25px;
      grid-template-columns: 1fr 1fr 1fr;
      grid-template-rows: 344px 344px;
      .item {
        position: relative;
        background-color: #fff;
        img {
          position: absolute;
          width: 148px;
          height: 148px;
          bottom: 5px;
          right: 14px;
        }
        .title {
          font-weight: 600;
          margin-left: 32px;
          margin-top: 32px;
          height: 32px;
          font-size: 18px;
          color: #374567;
          line-height: 32px;
          text-align: left;
        }
        .desc {
          margin-right: 32px;
          padding-top: 8px;
          margin-left: 32px;
          letter-spacing: 1.5px;
          font-size: 14px;
          text-align: justify;
          color: #7a8ba6;
          line-height: 24px;
        }
      }
    }
  }
  .sectionC {
    width: 100%;
    padding-bottom: 80px;
    .sec-title {
      font-size: 28px;
      font-weight: 500;
      line-height: 48px;
      color: #374567;
      text-align: center;
      padding: 70px 0 0 0;
    }
    .sec-sub-title {
      font-size: 14px;
      color: #7a8ba6;
      line-height: 24px;
      max-width: 1280px;
      margin: 24px auto 72px auto;
      text-align: center;
    }
    .content {
      width: 100%;
      .tabs {
        width: 100%;
        display: flex;
        background-color: #f9faff;
        .item {
          flex: 1;
          height: 136px;
          cursor: pointer;
          .tab {
            height: 100%;
            display: flex;
            justify-content: center;
            align-items: center;
            font-size: 18px;
            color: #374567;
            font-weight: 500;
            text-align: center;
          }
          .detail {
            .title {
              margin-top: 32px;
              margin-left: 24px;
              font-weight: 600;
              font-size: 18px;
              color: #374567;
              line-height: 24px;
              text-align: left;
              height: 24px;
              width: 352px;
            }
            .desc {
              margin-top: 10px;
              margin-left: 24px;
              font-size: 14px;
              color: #7a8ba6;
              line-height: 24px;
              span {
                margin-right: 12px;
              }
            }
          }
        }
        .item.active {
          width: 455px;
          height: 136px;
          border-top: 4px solid #2468ff;
          background-color: #fff;
        }
      }
      img {
        width: 100%;
        height: 720px;
      }
    }
  }
  .contactus {
    width: 100%;
    height: 180px;
    display: flex;
    flex-direction: column;
    align-items: center;
    background-image: linear-gradient(
      90deg,
      rgb(251, 252, 255),
      rgb(228, 234, 252) 75%,
      rgb(202, 222, 255)
    );
    .title {
      font-size: 30px;
      line-height: 40px;
      letter-spacing: 1.88px;
      text-align: center;
      color: #181818;
      padding-top: 49px;
      font-weight: 500;
    }
    .btn {
      margin-top: 20px;
      width: 108px;
      height: 36px;
      border-radius: 18px;
      background-image: linear-gradient(
        90deg,
        rgb(124, 172, 255),
        rgb(98, 140, 255)
      );
      margin: 20px auto;
      font-size: 14px;
      color: #fff;
      line-height: 36px;
      cursor: pointer;
      text-align: center;
      &:hover {
        background-image: linear-gradient(
          90deg,
          rgb(113, 165, 255),
          rgb(78, 125, 252)
        );
      }
    }
  }
}
</style>
<style>
.solution-container {
  top: 77px !important;
}
</style>
